(function(){
  const R = window.Ruma || {};
  const $ = (s, el=document) => el.querySelector(s);
  const $$ = (s, el=document) => [...el.querySelectorAll(s)];
  const reduceMotion = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const rate = (window.Shopify && Shopify.currency && +Shopify.currency.rate) || 1;
  const curCode = (window.Shopify && Shopify.currency && Shopify.currency.active) || "";

  // ---------- money ----------
  function formatMoney(cents){
    const fmt = R.moneyFormat || "${{amount}}";
    const n = (cents||0)/100;
    const withDelim = (num, dec, th, ds) => { const [i,f] = num.toFixed(dec).split("."); return i.replace(/\B(?=(\d{3})+(?!\d))/g, th) + (f ? ds+f : ""); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
      amount: withDelim(n,2,",","."), amount_no_decimals: withDelim(n,0,",","."),
      amount_with_comma_separator: withDelim(n,2,".",","), amount_no_decimals_with_comma_separator: withDelim(n,0,".",","),
      amount_with_apostrophe_separator: withDelim(n,2,"'",".")
    }[k] || withDelim(n,2,",",".")));
  }
  const withCur = c => formatMoney(c) + (curCode ? " " + curCode : "");

  // ---------- toast ----------
  let tt; function toast(msg){ const el=$("#toast"); if(!el) return; el.textContent=msg; el.classList.add("show"); clearTimeout(tt); tt=setTimeout(()=>el.classList.remove("show"),2400); }

  // ---------- mobile menu ----------
  const menuBtn=$("#menuBtn"), mnav=$("#mnav");
  if(menuBtn&&mnav){ menuBtn.onclick=()=>{ const o=mnav.classList.toggle("open"); menuBtn.setAttribute("aria-expanded",o); }; }

  // ---------- currency from the visitor's location ----------
  // on a first visit, switch to the shopper's own country (and its currency) when we sell there; a pick in the switcher sticks after that
  const curForm=$("#curForm"), curSel=$("#curSel");
  if(curForm&&curSel){
    let seen=true; try{ seen=!!localStorage.getItem("ruma-geo"); localStorage.setItem("ruma-geo","1"); }catch(e){}
    if(!seen) fetch("/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true",{headers:{Accept:"application/json"}})
      .then(r=>r.ok?r.json():null).then(d=>{
        const code=d&&d.detected_values&&d.detected_values.country&&d.detected_values.country.handle;
        if(code&&curSel.value!==code&&[...curSel.options].some(o=>o.value===code)){ curSel.value=code; curForm.submit(); }
      }).catch(()=>{});
  }

  // ---------- hero video ----------
  const hv=$("#heroVideo"), vb=$("#vidBtn");
  if(hv&&vb){
    const PAUSE='<svg viewBox="0 0 14 14" fill="currentColor" aria-hidden="true"><rect x="2" y="1" width="3.5" height="12"/><rect x="8.5" y="1" width="3.5" height="12"/></svg>';
    const PLAY='<svg viewBox="0 0 14 14" fill="currentColor" aria-hidden="true"><path d="M3 1v12l10-6z"/></svg>';
    const sync=()=>{ const on=!hv.paused; vb.innerHTML=on?PAUSE:PLAY; vb.setAttribute("aria-label",on?"Pause video":"Play video"); };
    // playback speed comes from the hero section's "Video speed" setting; browsers reset it when a video loads
    const speed=parseFloat((hv.closest("[data-speed]")||{dataset:{}}).dataset.speed)||1;
    const setSpeed=()=>{ hv.defaultPlaybackRate=speed; hv.playbackRate=speed; };
    setSpeed(); hv.addEventListener("loadedmetadata",setSpeed);
    hv.muted=true; hv.addEventListener("play",()=>{ setSpeed(); sync(); }); hv.addEventListener("pause",sync);
    if(reduceMotion){ hv.removeAttribute("autoplay"); hv.pause(); } else { const p=hv.play(); if(p&&p.catch) p.catch(()=>{}); }
    vb.onclick=()=>{ if(hv.paused){ const p=hv.play(); if(p&&p.catch) p.catch(()=>{}); } else hv.pause(); };
    sync();
  }

  // ---------- cart drawer ----------
  const drawer=$("#drawer"), scrim=$("#scrim");
  function openCart(on){
    if(!drawer) return;
    drawer.classList.toggle("open",on); scrim.classList.toggle("open",on); drawer.setAttribute("aria-hidden",!on);
    if(on){ $("#toast")&&$("#toast").classList.remove("show"); $("#closeCart").focus(); }
  }
  const getCart=()=>fetch(R.routes.cart + ".js", {headers:{Accept:"application/json"}}).then(r=>r.json());
  const postJSON=(url,body)=>fetch(url, {method:"POST", headers:{"Content-Type":"application/json",Accept:"application/json"}, body:JSON.stringify(body)}).then(r=>{ if(!r.ok) throw new Error(r.status); return r.json(); });
  const escHTML=t=>String(t==null?"":t).replace(/[&<>"]/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;"}[c]));
  const moneyShort=c=>formatMoney(c).replace(/[.,]00(?=\D*$)/,"");
  // delivery protection: a hidden line item the shopper keeps or drops at checkout; never shown as a cart row
  const PROT = drawer && drawer.dataset.protectId ? {id:+drawer.dataset.protectId, price:+drawer.dataset.protectPrice} : null;
  const onCartPage = document.body.classList.contains("template-cart");
  // compare-at prices are not in /cart.js, so read them from each product once
  const compareCache={};
  const compareAt=it=>{
    const h=it.handle; if(!compareCache[h]) compareCache[h]=fetch(`${R.routes.root.replace(/\/$/,"")}/products/${h}.js`).then(r=>r.json()).catch(()=>null);
    return compareCache[h].then(p=>{ const v=p&&p.variants.find(x=>x.id===it.variant_id); return v&&v.compare_at_price>(it.original_price||it.final_price) ? v.compare_at_price*it.quantity : 0; });
  };
  // $100 off the first couch: the code goes on the cart once a sofa or sectional is in it; Shopify allows one use per customer at checkout
  const FC = R.firstCouch && R.firstCouch.code ? R.firstCouch : null;
  const hasCode = cart => (cart.discount_codes||[]).some(d=>String(d.code).toUpperCase()===FC.code.toUpperCase());
  async function ensureFirstCouch(cart){
    if(!FC || hasCode(cart) || !cart.items.some(i=>/^(sofa|sectional)$/i.test(i.product_type||""))) return false;
    const key="ruma-fc-"+(cart.token||"");
    try{ if(sessionStorage.getItem(key)) return false; sessionStorage.setItem(key,"1"); }catch(e){}
    const codes=(cart.discount_codes||[]).map(d=>d.code).concat(FC.code).join(",");
    return postJSON(R.routes.cartUpdate + ".js", {discount:codes}).then(()=>true).catch(()=>false);
  }
  const TRASH='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3"/></svg>';
  async function renderCart(){
    if(!drawer) return;
    const cart = await getCart();
    if(await ensureFirstCouch(cart)){ if(onCartPage){ location.reload(); return; } return renderCart(); }
    const prot = PROT && cart.items.find(i=>i.variant_id===PROT.id);
    const goods = cart.items.filter(i=>!PROT||i.variant_id!==PROT.id);
    // protection only makes sense once, alongside something to protect
    if(prot && (!goods.length || prot.quantity!==1)){
      await postJSON(R.routes.cartChange + ".js", {id:prot.key, quantity:goods.length?1:0});
      if(onCartPage){ location.reload(); return; }
      return renderCart();
    }
    const goodsTotal = cart.total_price - (prot ? prot.final_line_price : 0);
    const box=$("#items"); box.innerHTML="";
    goods.forEach(it=>{
      const row=document.createElement("div"); row.className="item";
      const img = it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/i,"_300x$1$2")}" alt="" loading="lazy">` : "";
      row.innerHTML=`<a class="thumb" href="${it.url}">${img}</a>
        <div class="mid"><div><b><a href="${it.url}">${escHTML(it.product_title)}</a></b>${it.product_has_only_default_variant?"":`<span class="mono muted">${escHTML(it.variant_title)}</span>`}</div>
        <div class="ctl"><span class="qty"><button type="button" aria-label="Decrease quantity">−</button><span>${it.quantity}</span><button type="button" aria-label="Increase quantity">+</button></span><button type="button" class="del" aria-label="Remove ${escHTML(it.product_title)}">${TRASH}</button></div></div>
        <span class="pr"><s></s><span>${moneyShort(it.original_line_price||it.final_line_price)}</span></span>`;
      const [m,p]=row.querySelectorAll(".qty button");
      m.onclick=()=>changeQty(it.key, it.quantity-1);
      p.onclick=()=>changeQty(it.key, it.quantity+1);
      $(".del",row).onclick=()=>changeQty(it.key, 0);
      compareAt(it).then(c=>{ if(c) $(".pr s",row).textContent=moneyShort(c); });
      box.appendChild(row);
    });
    if(goods.length){
      const clear=document.createElement("button"); clear.type="button"; clear.className="clear-all"; clear.textContent="Remove all";
      clear.onclick=async()=>{ await postJSON(R.routes.cartClear + ".js", {}); renderCart(); };
      box.appendChild(clear);
    } else box.innerHTML='<p class="empty mono">Your cart is empty.</p>';
    $("#cartCount").textContent=goods.reduce((n,i)=>n+i.quantity,0);
    const threshold=Math.round((R.freeShipCents||0)*rate), left=threshold-goodsTotal;
    $("#shipText").textContent = !threshold ? "" : goodsTotal===0 ? `Free delivery on orders over ${formatMoney(threshold)}` : left>0 ? `${formatMoney(left)} away from free delivery` : "Your order ships free";
    $("#shipBar").style.width = threshold ? Math.min(100, goodsTotal/threshold*100)+"%" : "100%";
    const disc=cart.total_discount||0, dRow=$("#discRow");
    if(dRow){ dRow.hidden=!(disc>0&&goods.length); $("#discName").textContent=FC&&hasCode(cart)?FC.label:"Discount"; $("#discAmt").textContent="−"+moneyShort(disc); }
    const protRow=$("#protectRow"), skip=$("#skipProtect");
    if(protRow) protRow.hidden=!goods.length;
    if(skip) skip.hidden=!goods.length;
    $("#checkoutTotal").textContent = goods.length ? moneyShort(goodsTotal + (PROT ? PROT.price : 0)) : "";
    const fin=$("#finNote");
    if(fin){ const m=+fin.dataset.months||12, tot=goodsTotal+(PROT?PROT.price:0);
      fin.innerHTML = goods.length ? `Or as low as <b>${moneyShort(Math.ceil(tot/m/100)*100)}</b>/month over ${m} months with ${escHTML(fin.dataset.providers)}.<span class="mo-fine">Before interest. Subject to approval; final terms shown at checkout.</span>` : `Or pay over time with ${escHTML(fin.dataset.providers)}`; }
    $("#checkout").disabled = !goods.length;
  }
  async function changeQty(key, q){
    await postJSON(R.routes.cartChange + ".js", {id:key, quantity:Math.max(0,q)});
    renderCart();
  }
  // checkout keeps protection on the main button and drops it on "Continue without protection"
  async function setProtection(on){
    const cart=await getCart(), line=cart.items.find(i=>i.variant_id===PROT.id);
    if(on && !line) await postJSON(R.routes.cartAdd + ".js", {items:[{id:PROT.id, quantity:1}]});
    else if(on && line.quantity!==1) await postJSON(R.routes.cartChange + ".js", {id:line.key, quantity:1});
    else if(!on && line) await postJSON(R.routes.cartChange + ".js", {id:line.key, quantity:0});
  }
  $$("[data-checkout]").forEach(b=>b.addEventListener("click",async e=>{
    if(!PROT) return;
    e.preventDefault();
    const f=b.form, all=$$("[data-checkout]"); all.forEach(x=>x.disabled=true);
    try{ await setProtection(b.dataset.checkout==="with"); }
    catch(err){ toast("Couldn't update delivery protection. Please try again."); all.forEach(x=>x.disabled=false); return; }
    const h=document.createElement("input"); h.type="hidden"; h.name="checkout"; h.value="1"; f.appendChild(h); f.submit();
  }));
  async function addToCart(body, isJson){
    const res = await fetch(R.routes.cartAdd + ".js", {method:"POST", headers: isJson?{"Content-Type":"application/json",Accept:"application/json"}:{Accept:"application/json"}, body});
    const data = await res.json();
    if(!res.ok){ toast(data.description || data.message || "Couldn't add to cart"); return false; }
    await renderCart(); openCart(true); return true;
  }
  const cartBtn=$("#cartBtn");
  if(cartBtn&&drawer){ cartBtn.addEventListener("click",e=>{ e.preventDefault(); renderCart(); openCart(true); }); }
  $("#closeCart")&&($("#closeCart").onclick=()=>openCart(false));
  scrim&&(scrim.onclick=()=>openCart(false));
  document.addEventListener("keydown",e=>{ if(e.key==="Escape") openCart(false); });
  document.addEventListener("submit",e=>{
    const f=e.target;
    const covOn=f.matches("[data-product-form]")&&f.querySelector("[data-covers-on]:checked");
    if(covOn){ e.preventDefault(); const b=f.querySelector("[type=submit]"); if(b) b.disabled=true;
      let map={}; try{ map=JSON.parse(f.querySelector("[data-covers]").dataset.covers); }catch(err){}
      const vid=String(f.querySelector("[name=id]").value), qty=+((f.querySelector("[name=quantity]")||{}).value||1)||1, cnt={};
      (map[vid]||[]).forEach(id=>cnt[id]=(cnt[id]||0)+qty);
      const items=[{id:+vid,quantity:qty}].concat(Object.keys(cnt).map(id=>({id:+id,quantity:cnt[id]})));
      addToCart(JSON.stringify({items}),true).finally(()=>{ if(b) b.disabled=false; }); return; }
    if(f.matches("[data-quick-add]")||f.matches("[data-product-form]")){ e.preventDefault(); const b=f.querySelector("[type=submit]"); if(b) b.disabled=true; addToCart(new FormData(f)).finally(()=>{ if(b) b.disabled=false; }); }
  });

  // ---------- variant logic shared by product page, cards and bundle ----------
  function findVariant(product, sel){ return product.variants.find(v=>v.options.every((o,i)=>o===sel[i])); }
  function bestVariant(product, sel, changed){
    return findVariant(product, sel)
      || product.variants.find(v=>v.available && v.options[changed]===sel[changed])
      || product.variants.find(v=>v.options[changed]===sel[changed]);
  }
  function markSoldOut(root, product, sel){
    $$("[data-opt]", root).forEach(b=>{
      const i=+b.dataset.opt, val=b.dataset.val;
      const test=sel.slice(); test[i]=val;
      const ok=product.variants.some(v=>v.available && v.options.every((o,k)=>o===test[k]));
      b.classList.toggle("soldout", !ok);
    });
  }

  // product cards: colour squares switch the photo and the variant added
  $$("[data-card]").forEach(card=>{
    const j=$("[data-card-json]",card); if(!j) return;
    const data=JSON.parse(j.textContent), idInput=$("input[name=id]",card), img=$("[data-card-img]",card)||$(".scard-media img, .media img",card), btn=$(".add",card), fname=$(".fname",card);
    const pick=sq=>{ const i=+sq.dataset.opt-1, val=sq.dataset.val; return data.variants.find(x=>x.options[i]===val&&x.available)||data.variants.find(x=>x.options[i]===val); };
    // the photo for the chosen colour; hovering another colour previews it, moving away shows the chosen one again
    let chosen=null;
    const showImg=src=>{ if(!src||!img) return; if(chosen===null) chosen=img.currentSrc||img.src; img.removeAttribute("srcset"); if(img.src!==src) img.src=src; };
    const canHover=matchMedia("(hover: hover) and (pointer: fine)").matches;
    if(canHover){
      let warmed=false;
      card.addEventListener("mouseenter",()=>{ if(warmed) return; warmed=true; data.variants.forEach(x=>{ if(x.img){ const p=new Image(); p.src=x.img; } }); });
      $$(".sq",card).forEach(sq=>sq.addEventListener("mouseenter",()=>{ const v=pick(sq); if(v) showImg(v.img); if(fname) fname.textContent=sq.dataset.val; }));
      const group=$(".swatches, .scard-sw",card);
      if(group) group.addEventListener("mouseleave",()=>{
        const on=$(".sq[aria-pressed=true]",card);
        if(fname&&on) fname.textContent=on.dataset.val;
        if(chosen) showImg(chosen);
      });
    }
    $$(".sq",card).forEach(sq=>sq.addEventListener("click",()=>{
      const v=pick(sq), val=sq.dataset.val;
      if(!v) return;
      idInput.value=v.id; $$(".sq",card).forEach(s=>s.setAttribute("aria-pressed",s===sq)); if(fname) fname.textContent=val;
      if(v.img&&img){ chosen=null; showImg(v.img); chosen=v.img; }
      btn.disabled=!v.available; btn.innerHTML=v.available?'Add to cart <span aria-hidden="true">+</span>':"Sold out";
    }));
  });

  // product page
  const pp=$("[data-product]");
  if(pp){
    const product=JSON.parse($("[data-product-json]",pp).textContent);
    const form=$("[data-product-form]",pp), select=$("[data-variant-select]",pp);
    let current=product.variants.find(v=>String(v.id)===select.value)||product.variants[0];
    const sel=current.options.slice();
    const show=id=>{ $$(".hp-main .slide",pp).forEach(s=>s.hidden=s.dataset.mediaId!==String(id)); $$("[data-thumb]",pp).forEach(t=>t.setAttribute("aria-pressed",t.dataset.thumb===String(id))); };
    $$("[data-thumb]",pp).forEach(t=>t.onclick=()=>show(t.dataset.thumb));
    const mbar=$("#mbar");
    function update(){
      select.value=current.id;
      const on=current.compare_at_price>current.price, pct=on?Math.round((current.compare_at_price-current.price)/current.compare_at_price*100):0;
      $("[data-price]",pp).textContent=withCur(current.price);
      $("[data-compare]",pp).textContent=on?formatMoney(current.compare_at_price):"";
      const save=$("[data-save]",pp), pc=$("[data-pct]",pp);
      save.hidden=!on; pc.hidden=!on; if(on){ save.textContent="Save "+formatMoney(current.compare_at_price-current.price); pc.textContent=pct+"% OFF"; }
      $("[data-item-price]",pp).textContent=formatMoney(current.price);
      $("[data-item-compare]",pp).textContent=on?formatMoney(current.compare_at_price):"";
      $("[data-status]",pp).textContent=current.available?"In stock":"Sold out";
      const atc=$("[data-atc]",pp); atc.disabled=!current.available;
      $("[data-atc-text]",pp).innerHTML=current.available?`Add to cart – ${on?`<s>${formatMoney(current.compare_at_price)}</s> `:""}${withCur(current.price)}`:"Sold out";
      $$("[data-opt]",pp).forEach(b=>b.setAttribute("aria-pressed", sel[+b.dataset.opt]===b.dataset.val));
      $$("[data-opt-label]",pp).forEach(l=>l.textContent=sel[+l.dataset.optLabel]);
      markSoldOut(pp, product, sel);
      if(current.featured_media) show(current.featured_media.id);
      if(mbar){ $("[data-mbar-price]",mbar).textContent=withCur(current.price); }
      const mo=$("[data-mo]",pp); if(mo){ mo.textContent=moneyShort(Math.ceil(current.price/(+mo.dataset.months||12)/100)*100); }
      const u=new URL(location.href); u.searchParams.set("variant",current.id); history.replaceState(null,"",u);
    }
    $$("[data-opt]",pp).forEach(b=>b.addEventListener("click",()=>{
      const i=+b.dataset.opt; sel[i]=b.dataset.val;
      current=bestVariant(product, sel, i)||current; current.options.forEach((o,k)=>sel[k]=o); update();
    }));
    markSoldOut(pp, product, sel);
    // review quotes on the photo
    const qs=$$("[data-quote]",pp), dots=$$("[data-dot]",pp); let qi=0;
    const showQ=k=>{ qi=k; qs.forEach((q,j)=>q.hidden=j!==k); dots.forEach((d,j)=>d.setAttribute("aria-pressed",j===k)); };
    dots.forEach(d=>d.onclick=()=>showQ(+d.dataset.dot));
    if(qs.length>1&&!reduceMotion) setInterval(()=>showQ((qi+1)%qs.length),5000);
    // sticky add-to-cart bar on phones
    if(mbar){ mbar.hidden=false; document.body.classList.add("has-mbar"); $("[data-mbar-buy]",mbar).onclick=()=>form.requestSubmit(); }
  }

  // bundle builder: an optional couch picked from a list, then fixed pieces, each in its own colour
  const bb=$("[data-bundle]");
  if(bb){
    const slides=$$("[data-b-slide]",bb), thumbs=$$("[data-b-thumb]",bb);
    const showSlide=k=>{ slides.forEach((s,j)=>s.hidden=j!==k); thumbs.forEach((t,j)=>t.setAttribute("aria-pressed",j===k)); };
    thumbs.forEach(t=>t.onclick=()=>showSlide(+t.dataset.bThumb));
    const sized=(u,w)=>/[?&]width=\d+/.test(u)?u.replace(/([?&]width=)\d+/,"$1"+w):u+(u.includes("?")?"&":"?")+"width="+w;
    const setImg=(im,src,alt)=>{ if(!im||!src) return; im.removeAttribute("srcset"); im.src=src; if(alt!=null) im.alt=alt; };
    const items=$$("[data-b-item]",bb).map(el=>{
      const data=JSON.parse($("[data-b-json]",el).textContent), all=Array.isArray(data)?data:[data], pick=+(el.dataset.bStart||0);
      const p=all[pick], v=p.variants.find(x=>x.available)||p.variants[0];
      return {el,all,pick,p,v,sel:v.options.slice()};
    });
    function paint(it,idx,init){
      const box=$(`[data-b-opts="${it.pick}"]`,it.el), title=$("[data-b-title]",it.el), on=it.v.compare_at_price>it.v.price;
      $$("[data-b-opts]",it.el).forEach(g=>g.hidden=g!==box);
      $$("[data-b-pick]",it.el).forEach(b=>b.setAttribute("aria-pressed",+b.dataset.bPick===it.pick));
      if(title){ title.textContent=it.p.title; title.href=it.p.url; }
      $("[data-item-price]",it.el).textContent=formatMoney(it.v.price);
      $("[data-item-compare]",it.el).textContent=on?formatMoney(it.v.compare_at_price):"";
      if(box){
        $$("[data-opt]",box).forEach(b=>b.setAttribute("aria-pressed",it.sel[+b.dataset.opt]===b.dataset.val));
        $$("[data-opt-val]",box).forEach(l=>l.textContent=it.sel[+l.dataset.optVal]);
        markSoldOut(box,it.p,it.sel);
      }
      if(it.v.img&&!init){
        const alt=it.p.title+(it.p.variants.length>1?" in "+it.v.options.join(" / "):"");
        setImg($("[data-b-img]",it.el)||$(".bimg img",it.el),sized(it.v.img,240));
        setImg(slides[idx]&&$("img",slides[idx]),sized(it.v.img,1400),alt);
        setImg(thumbs[idx]&&$("img",thumbs[idx]),sized(it.v.img,400));
      }
    }
    function totals(){
      let now=0, was=0, ok=true;
      items.forEach(it=>{ now+=it.v.price; was+=Math.max(it.v.compare_at_price||0,it.v.price); ok=ok&&it.v.available; });
      const on=was>now;
      $("[data-b-now]",bb).textContent=withCur(now); $("[data-b-was]",bb).textContent=on?formatMoney(was):"";
      const s=$("[data-b-save]",bb), pc=$("[data-b-pct]",bb); s.hidden=pc.hidden=!on;
      if(on){ s.textContent="Save "+formatMoney(was-now); pc.textContent=Math.round((was-now)/was*100)+"% OFF"; }
      const atc=$("[data-b-atc]",bb); atc.disabled=!ok;
      $("[data-b-atc-text]",bb).innerHTML=ok?`Add to cart – ${on?`<s>${formatMoney(was)}</s> `:""}${withCur(now)}`:"One piece is sold out";
    }
    items.forEach((it,idx)=>it.el.addEventListener("click",e=>{
      const pick=e.target.closest("[data-b-pick]"), opt=e.target.closest("[data-opt]");
      if(pick){
        const k=+pick.dataset.bPick; if(k===it.pick) return;
        // keep the colour already chosen when the new couch comes in it
        it.pick=k; it.p=it.all[k]; it.v=findVariant(it.p,it.sel)||it.p.variants.find(x=>x.available)||it.p.variants[0];
      } else if(opt){
        const i=+opt.dataset.opt; it.sel[i]=opt.dataset.val; it.v=bestVariant(it.p,it.sel,i)||it.v;
      } else return;
      it.sel=it.v.options.slice(); paint(it,idx); showSlide(idx); totals();
    }));
    $("[data-b-atc]",bb).onclick=()=>addToCart(JSON.stringify({items:items.map(it=>({id:it.v.id,quantity:1}))}),true);
    items.forEach((it,idx)=>paint(it,idx,true)); totals();
  }

  // ---------- home: shape tabs and colour preview ----------
  $$("[data-shapes]").forEach(sec=>{
    const tabs=$$("[data-shape-tab]",sec), panels=$$("[data-shape-panel]",sec);
    tabs.forEach(t=>t.onclick=()=>{ tabs.forEach(x=>x.setAttribute("aria-pressed",x===t)); panels.forEach(p=>p.hidden=p.dataset.shapePanel!==t.dataset.shapeTab); });
  });
  $$("[data-colours]").forEach(sec=>{
    const btns=$$("[data-colour-btn]",sec), views=$$("[data-colour-view]",sec);
    btns.forEach(b=>b.onclick=()=>{ btns.forEach(x=>x.setAttribute("aria-pressed",x===b)); views.forEach(v=>v.hidden=v.dataset.colourView!==b.dataset.colourBtn); });
  });

  // ---------- collection sort ----------
  const sort=$("[data-sort]");
  if(sort) sort.onchange=()=>{ const u=new URL(location.href); u.searchParams.set("sort_by",sort.value); u.searchParams.delete("page"); location.href=u; };

  renderCart().catch(()=>{});
})();
